import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
import { PageHeader } from '../../components/ui/PageHeader';
import { ArrowRight } from 'lucide-react';

const steps = [
  {
    number: 1,
    title: 'Update Account Balances',
    description: 'Update all account balances on the Accounts page to reflect current values, then click Snapshot to save the month-end totals.',
    path: '/finance/master-accounts',
    linkLabel: 'Go to Accounts',
  },
  {
    number: 2,
    title: 'Update Transactions',
    description: 'Enter any new transactions for the month in the Cashflow section to ensure income and expenses are up to date.',
    path: '/finance/cashflow',
    linkLabel: 'Go to Cashflow',
  },
  {
    number: 3,
    title: 'Update Investments',
    description: 'Update any changes in asset holdings or prices in the Investments section.',
    path: '/finance/investments',
    linkLabel: 'Go to Investments',
  },
  {
    number: 4,
    title: 'Review Subscriptions',
    description: 'Verify any new or cancelled subscriptions are reflected. Remove inactive subscriptions and add any new recurring charges.',
    path: '/finance/subscriptions',
    linkLabel: 'Go to Subscriptions',
  },
];

export default function MECloseInstructions() {
  return (
    <div>
      <PageHeader
        title="ME Close Instructions"
        subtitle="Month-end close procedures"
      />

      <div className="space-y-4">
        {steps.map((step) => (
          <Card key={step.number}>
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-accent/20 text-accent flex items-center justify-center font-bold text-sm">
                {step.number}
              </div>
              <div className="flex-1">
                <h3 className="text-text-primary font-semibold mb-1">{step.title}</h3>
                <p className="text-text-secondary text-sm mb-3">{step.description}</p>
                <Link
                  to={step.path}
                  className="inline-flex items-center gap-1.5 text-accent text-sm font-medium hover:underline"
                >
                  {step.linkLabel}
                  <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
